import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import Modal from 'components/shared/modal-form';
import useModal from 'components/shared/modal-form/useModal.js';
import environment from 'environment';

import buttonOff from 'images/direct-pay/getStartedOff.png';
import buttonOn from 'images/direct-pay/getStartedOn.png';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    container: {
        display: 'flex',
        flexWrap: 'nowrap',
        backgroundColor: '#F7B334',
        minHeight: '270px',
        [theme.breakpoints.down('sm')]: {
            minHeight: '200px',
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: '270px',
        },
        [theme.breakpoints.up('md')]: {
            minHeight: '270px',
        }
    },
    title: {
        font: 'normal normal 900 60px/72px brandon-grotesque',
        color: '#ffffff',
        [theme.breakpoints.down('sm')]: {
            font: 'normal normal 900 30px/32px brandon-grotesque',
            padding: '0 55px 20px 55px',
        },
        [theme.breakpoints.up('sm')]: {
            font: 'normal normal 900 45px/52px brandon-grotesque',
            padding: '0 20% 30px 20%'
        },
        [theme.breakpoints.up('md')]: {
            font: 'normal normal 900 60px/72px brandon-grotesque',
            padding: '10px 55px'
        }

    },
    titleContainer: {
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(4),
        textAlign: 'center'
    },
    button: {
        cursor: 'pointer',
        alignItems: 'center',
        position:' relative',
        [theme.breakpoints.down('sm')]: {
            width: '150px'
        },
        [theme.breakpoints.up('sm')]: {
            width: '180px'
        },
        [theme.breakpoints.up('md')]: {
            width: '220px',
            top: '14px',
            alignItems: 'center',
            lineHeight: '72px',
            marginLeft: '40px'
        }
    },
    desktop: {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        },
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        },
        [theme.breakpoints.up('md')]: {
            display: 'block'
        }
    },
    mobile: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'block'
        },
        [theme.breakpoints.up('sm')]: {
            display: 'block'
        },
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    }
}));

const SectionFive = () => {
    const classes = useStyles();
    const { isShowing, toggle } = useModal();

    return (
        <section className={classes.container}>
            <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            >
                <Grid item xs={12}>
                        <Box className={classes.desktop}>
                            <Box className={classes.title}>
                                sign-up today and let’s grow, together!
                                <img src={buttonOff} alt="Get Started" className={classes.button}
                                onMouseOver={e => e.currentTarget.src = buttonOn}
                                onMouseOut={e => e.currentTarget.src = buttonOff}
                                onClick={toggle} />
                            </Box>
                        </Box>
                        <Box className={classes.mobile}>
                            <Box className={classes.title}>
                                sign-up today and let’s grow, together!
                            </Box>
                            <Box>
                                <img src={buttonOff} alt="Get Started" className={classes.button}
                                onMouseOver={e => e.currentTarget.src = buttonOn}
                                onMouseOut={e => e.currentTarget.src = buttonOff}
                                onClick={toggle} />
                            </Box>
                        </Box>
                </Grid>
            </Grid>
            <div className="clearfix" />
            <Modal
                form="inquiry.partner"
                email={environment.communications.partnerInquiry}
                isShowing={isShowing}
                hide={toggle}
                directPay={true}
            />
        </section>
    );
}

export default SectionFive;
